const assertUnreachable = ()=>{
    throw new Error('Assertion failure');
};

export { assertUnreachable };
//# sourceMappingURL=assertUnreachable.mjs.map
